import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { SEO } from "./components";
import { SEOConfig } from "./config/seo-configure";

import "./styles/index.less";

ReactDOM.render(
  <React.StrictMode>
    <SEO image={SEOConfig.image} />
    <App />
  </React.StrictMode>,
  document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
